export default __webpack_public_path__ + "110703992f03e7fdf2a8fab5440b4fad.gif";